module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "landing-workable"
  }, [_c('div', {
    staticClass: "inner-container"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("\n      Nossas vagas\n    ")]), _vm._v(" "), _c('ul', {
    staticClass: "jobs-list"
  }, _vm._l((_vm.jobs), function(job) {
    return _c('li', {
      staticClass: " jobs-item"
    }, [_c('h3', [_vm._v("\n          " + _vm._s(job.title) + "\n        ")]), _vm._v(" "), _c('round-button', {
      staticClass: "show-job",
      attrs: {
        "href": job.url,
        "target": "_blank"
      }
    }, [_vm._v("\n          Inscreva-se\n        ")])], 1)
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3a177c0e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LandingWorkable.vue
// module id = 137
// module chunks = 1